import Vue from 'vue';
import numeral from 'numeral';

Vue.filter('numeral', function(val, format = '0,0') {
    return numeral(String(val)).format(format);
});